import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef,
  Component,
  Inject,
  Input,
  input,
  PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { Router } from '@angular/router';
import { SpinnerSegment } from '../../../Interfaces/interfaces';

@Component({
  selector: 'app-spin',
  imports: [CommonModule, SpinnerComponent],
  templateUrl: './spin.component.html',
  styleUrl: './spin.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinComponent {
  isAmountCredited: boolean = true;

  private baseSegments: SpinnerSegment[] = [
    { id: 'seg-01', prize: '$1', icon: 'heroTrophy' },
    { id: 'seg-02', prize: '$2', icon: 'ionDiamond' },
    { id: 'seg-03', prize: '$3', icon: 'heroTrophy' },
    { id: 'seg-04', prize: '$5', icon: 'hugeMoneyBag02' },
    { id: 'seg-05', prize: '$6', icon: 'heroCurrencyDollar' },
    { id: 'seg-06', prize: '$8', icon: 'ionDiamond' },
    { id: 'seg-07', prize: '$9', icon: 'heroCurrencyDollar' },
    { id: 'seg-08', prize: '$13', icon: 'hugeMoneyBag02' },
    { id: 'seg-09', prize: '$15', icon: 'heroGift' },
    { id: 'seg-10', prize: '$20', icon: 'heroCurrencyDollar' },
  ];

  segments: SpinnerSegment[] = [...this.baseSegments];

  private readonly amountSegmentMap: Record<number, SpinnerSegment[]> = {
    1: [
      { id: 'seg-01', prize: '$0', icon: 'heroTrophy' },
      { id: 'seg-02', prize: '$1', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$2', icon: 'heroCurrencyDollar' },
      { id: 'seg-04', prize: '$2', icon: 'heroTrophy' },
      { id: 'seg-05', prize: '$0', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$3', icon: 'hugeMoneyBag02' },
      { id: 'seg-07', prize: '$4', icon: 'heroCurrencyDollar' },
      { id: 'seg-08', prize: '$5', icon: 'hugeMoneyBag02' },
      { id: 'seg-09', prize: '$2', icon: 'ionDiamond' },
      { id: 'seg-10', prize: '$1', icon: 'heroGift' },
    ],
    2: [
      { id: 'seg-01', prize: '$1', icon: 'heroTrophy' },
      { id: 'seg-02', prize: '$0', icon: 'heroCurrencyDollar' },
      { id: 'seg-03', prize: '$2', icon: 'ionDiamond' },
      { id: 'seg-04', prize: '$3', icon: 'hugeMoneyBag02' },
      { id: 'seg-05', prize: '$4', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$4', icon: 'heroTrophy' },
      { id: 'seg-07', prize: '$5', icon: 'ionDiamond' },
      { id: 'seg-08', prize: '$6', icon: 'hugeMoneyBag02' },
      { id: 'seg-09', prize: '$1', icon: 'heroGift' },
      { id: 'seg-10', prize: '$2', icon: 'heroCurrencyDollar' },
    ],
    3: [
      { id: 'seg-01', prize: '$0', icon: 'heroTrophy' },
      { id: 'seg-02', prize: '$1', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$2', icon: 'heroCurrencyDollar' },
      { id: 'seg-04', prize: '$1', icon: 'heroTrophy' },
      { id: 'seg-05', prize: '$2', icon: 'ionDiamond' },
      { id: 'seg-06', prize: '$3', icon: 'hugeMoneyBag02' },
      { id: 'seg-07', prize: '$4', icon: 'heroCurrencyDollar' },
      { id: 'seg-08', prize: '$5', icon: 'heroTrophy' },
      { id: 'seg-09', prize: '$7', icon: 'hugeMoneyBag02' },
      { id: 'seg-10', prize: '$9', icon: 'heroGift' },
    ],
    4: [
      { id: 'seg-01', prize: '$1', icon: 'heroTrophy' },
      { id: 'seg-02', prize: '$2', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$3', icon: 'heroCurrencyDollar' },
      { id: 'seg-04', prize: '$4', icon: 'hugeMoneyBag02' },
      { id: 'seg-05', prize: '$6', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$7', icon: 'ionDiamond' },
      { id: 'seg-07', prize: '$8', icon: 'hugeMoneyBag02' },
      { id: 'seg-08', prize: '$9', icon: 'heroCurrencyDollar' },
      { id: 'seg-09', prize: '$0', icon: 'heroTrophy' },
      { id: 'seg-10', prize: '$12', icon: 'heroGift' },
    ],

    5: [
      { id: 'seg-01', prize: '$1', icon: 'heroTrophy' },
      { id: 'seg-02', prize: '$2', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$3', icon: 'heroTrophy' },
      { id: 'seg-04', prize: '$5', icon: 'hugeMoneyBag02' },
      { id: 'seg-05', prize: '$6', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$8', icon: 'ionDiamond' },
      { id: 'seg-07', prize: '$9', icon: 'heroCurrencyDollar' },
      { id: 'seg-08', prize: '$13', icon: 'hugeMoneyBag02' },
      { id: 'seg-09', prize: '$15', icon: 'heroGift' },
      { id: 'seg-10', prize: '$20', icon: 'heroCurrencyDollar' },
    ],
    10: [
      { id: 'seg-01', prize: '$2', icon: 'heroTrophy' },
      { id: 'seg-10', prize: '$17', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$4', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$8', icon: 'hugeMoneyBag02' },
      { id: 'seg-02', prize: '$5', icon: 'heroTrophy' },
      { id: 'seg-08', prize: '$12', icon: 'hugeMoneyBag02' },
      { id: 'seg-04', prize: '$7', icon: 'heroCurrencyDollar' },
      { id: 'seg-05', prize: '$20', icon: 'heroGift' },
      { id: 'seg-07', prize: '$10', icon: 'ionDiamond' },
      { id: 'seg-09', prize: '$14', icon: 'hugeMoneyBag02' },
    ],
    15: [
      { id: 'seg-01', prize: '$5', icon: 'heroTrophy' },
      { id: 'seg-09', prize: '$25', icon: 'hugeMoneyBag02' },
      { id: 'seg-02', prize: '$8', icon: 'heroTrophy' },
      { id: 'seg-07', prize: '$19', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$10', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$17', icon: 'hugeMoneyBag02' },
      { id: 'seg-04', prize: '$13', icon: 'heroCurrencyDollar' },
      { id: 'seg-10', prize: '$30', icon: 'ionDiamond' },
      { id: 'seg-05', prize: '$15', icon: 'heroGift' },
      { id: 'seg-08', prize: '$22', icon: 'hugeMoneyBag02' },
    ],
    20: [
      { id: 'seg-01', prize: '$5', icon: 'heroTrophy' },
      { id: 'seg-09', prize: '$45', icon: 'hugeMoneyBag02' },
      { id: 'seg-02', prize: '$10', icon: 'heroTrophy' },
      { id: 'seg-07', prize: '$35', icon: 'ionDiamond' },
      { id: 'seg-03', prize: '$15', icon: 'heroCurrencyDollar' },
      { id: 'seg-06', prize: '$30', icon: 'hugeMoneyBag02' },
      { id: 'seg-04', prize: '$20', icon: 'heroCurrencyDollar' },
      { id: 'seg-10', prize: '$50', icon: 'ionDiamond' },
      { id: 'seg-05', prize: '$25', icon: 'heroGift' },
      { id: 'seg-08', prize: '$40', icon: 'hugeMoneyBag02' },
    ],
  };

  amountChoices: number[] = [1, 2, 3, 4, 5, 10, 15, 20];

  spinHistory: { no: number; win: string; date: string }[] = [];

  private _spinAmount: string = '5';

  get spinAmount(): string {
    return this._spinAmount;
  }

  set spinAmount(value: string) {
    this._spinAmount = value;
    this.updateSegmentValues();
  }

  // Add these variables for the Winner Modal
  showWinnerModal: boolean = false;
  private winnerModalTimeout: any;
  private readonly WINNER_MODAL_AUTO_CLOSE_MS = 5000;

  closeWinnerModal() {
    this.showWinnerModal = false;
    if (this.winnerModalTimeout) {
      clearTimeout(this.winnerModalTimeout);
      this.winnerModalTimeout = null;
    }
    this.cdr.detectChanges();
  }

  isSpinning = false;
  rotation = 0;
  lastWin: string | null = null;
  highlightedIndex: number | null = null;
  private highlightTimeout: any;
  private readonly HIGHLIGHT_DURATION_MS = 6000;

  customerid: any;
  private readonly SPIN_DURATION = 4000;
  private readonly MIN_SPINS = 5;

  public readonly segmentAngle = 360 / this.segments.length;

  isSpinAllowed!: boolean;

  remainingTimeInSeconds: number = 0;
  formattedTime: string = '';
  private countdownInterval: any;

  segmentColors: Record<string, string> = {
    'seg-01': '#0F172A', // Deep navy (card base)
    'seg-02': 'linear-gradient(135deg, #00E5D4, #00F0FF)', // Neon teal
    'seg-03': '#111827', // Dark slate
    'seg-04': '#00CFC0', // Slightly muted teal
    'seg-05': '#0B1220', // Darker navy
    'seg-06': '#00F0FF', // Bright cyan highlight
    'seg-07': '#0E1A2B', // Blue-black
    'seg-08': '#14D9C4', // Soft aqua
    'seg-09': '#0A0F1C', // Almost black
    'seg-10': '#1EE6D6', // Neon mint
  };
  readonly positionColors: string[] = [
    '#0F172A',
    'linear-gradient(135deg, #00E5D4, #00F0FF)',
    '#111827',
    '#00CFC0',
    '#0B1220',
    '#00F0FF',
    '#0E1A2B',
    '#14D9C4',
    '#0A0F1C',
    '#1EE6D6',
  ];
  iconColors: Record<string, string> = {
    'seg-01': '#FFD166', // Gold (bonus badge style)
    'seg-02': '#FF9F43', // Orange (HOT badge glow)
    'seg-03': '#00F5D4', // Neon aqua
    'seg-04': '#C99AE0', // Soft purple (logo accents)
    'seg-05': '#FFE66D', // Bright yellow
    'seg-06': '#00E0FF', // Cyan glow
    'seg-07': '#2AF598', // Green-teal neon
    'seg-08': '#FFB86B', // Warm orange
    'seg-09': '#00FFD1', // Mint neon
    'seg-10': '#C4B5FD', // Light violet
  };

  wheelGradient = this.buildWheelGradient();

  getIconColor(segmentOrIndex: string | number): string {
    if (typeof segmentOrIndex === 'number') {
      const idx = segmentOrIndex;
      const segId = this.segments[idx]?.id;
      if (segId && this.iconColors[segId]) return this.iconColors[segId];

      const base = this.positionColors[idx] || '#ffffff';
      const finalColor = this.lightenColor(base, 35);
      return finalColor;
    }

    const explicit = this.iconColors[segmentOrIndex];
    if (explicit) return explicit;
    const base = this.segmentColors[segmentOrIndex] || '#ffffff';
    return this.lightenColor(base, 35);
  }

  private lightenColor(hex: string, amount: number): string {
    const clean = hex.replace('#', '');
    const normalized =
      clean.length === 3
        ? clean
            .split('')
            .map((c) => c + c)
            .join('')
        : clean;
    const bigint = parseInt(normalized, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    const pct = Math.max(0, Math.min(100, amount)) / 100;
    r = Math.round(r + (255 - r) * pct);
    g = Math.round(g + (255 - g) * pct);
    b = Math.round(b + (255 - b) * pct);

    const toHex = (v: number) => v.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  private buildWheelGradient(): string {
    return 'transparent';
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    const customerId = localStorage.getItem('customerId');
    this.customerid = customerId;
  }

  isMobile() {
    return window.innerWidth < 768;
  }
  private lastBalanceFetchAt: number | null = null;
  private balanceFetchPromise: Promise<void> | null = null;
  private readonly BALANCE_TTL_MS = 15000;

  async ngOnInit(): Promise<void> {
    await this.updateSegmentValues();
  }

  svgSegmentsData: any[] = [];

  private updateSvgSegments(): void {
    const N = this.segments.length;
    if (N === 0) return;

    const CX = 180,
      CY = 180;
    const OUTER_R = 173;
    const INNER_R = 107;
    const R_C = 8;
    const SEG_ANG = 360 / N;
    const GAP = 0;
    const START_ANG = -90 - SEG_ANG / 2;

    this.svgSegmentsData = this.segments.map((seg, i) => {
      const isBright = i % 2 === 0;
      const isSpecial =
        seg.prize.toUpperCase().includes('NEXT') ||
        seg.prize.toUpperCase().includes('TRY') ||
        seg.prize === '$0';

      let fill = isSpecial ? '#FFFFFF' : isBright ? '#263541' : '#11222e';
      let textColor = isSpecial ? '#000000' : '#FFFFFF';

      const a1_deg = START_ANG + i * SEG_ANG + GAP / 2;
      const a2_deg = START_ANG + (i + 1) * SEG_ANG - GAP / 2;
      const a1 = (a1_deg * Math.PI) / 180;
      const a2 = (a2_deg * Math.PI) / 180;
      const RO = OUTER_R - R_C;
      const RI = INNER_R + R_C;

      const d_out = Math.asin(R_C / RO);
      const d_in = Math.asin(R_C / RI);

      const pt = (r: number, ang: number) => ({
        x: CX + r * Math.cos(ang),
        y: CY + r * Math.sin(ang),
      });

      const O1_ang = a1 + d_out;
      const O2_ang = a2 - d_out;
      const O3_ang = a2 - d_in;
      const O4_ang = a1 + d_in;

      const O1 = pt(RO, O1_ang);
      const O2 = pt(RO, O2_ang);
      const O3 = pt(RI, O3_ang);
      const O4 = pt(RI, O4_ang);

      const P1_line = {
        x: O1.x + R_C * Math.cos(a1 - Math.PI / 2),
        y: O1.y + R_C * Math.sin(a1 - Math.PI / 2),
      };
      const P1_arc = pt(OUTER_R, O1_ang);
      const P2_arc = pt(OUTER_R, O2_ang);
      const P2_line = {
        x: O2.x + R_C * Math.cos(a2 + Math.PI / 2),
        y: O2.y + R_C * Math.sin(a2 + Math.PI / 2),
      };
      const P3_line = {
        x: O3.x + R_C * Math.cos(a2 + Math.PI / 2),
        y: O3.y + R_C * Math.sin(a2 + Math.PI / 2),
      };
      const P3_arc = pt(INNER_R, O3_ang);
      const P4_arc = pt(INNER_R, O4_ang);
      const P4_line = {
        x: O4.x + R_C * Math.cos(a1 - Math.PI / 2),
        y: O4.y + R_C * Math.sin(a1 - Math.PI / 2),
      };
      const large = a2 - a1 > Math.PI ? 1 : 0;

      const pathData =
        `M ${P1_line.x.toFixed(2)} ${P1_line.y.toFixed(2)} ` +
        `A ${R_C} ${R_C} 0 0 1 ${P1_arc.x.toFixed(2)} ${P1_arc.y.toFixed(2)} ` +
        `A ${OUTER_R} ${OUTER_R} 0 ${large} 1 ${P2_arc.x.toFixed(2)} ${P2_arc.y.toFixed(2)} ` +
        `A ${R_C} ${R_C} 0 0 1 ${P2_line.x.toFixed(2)} ${P2_line.y.toFixed(2)} ` +
        `L ${P3_line.x.toFixed(2)} ${P3_line.y.toFixed(2)} ` +
        `A ${R_C} ${R_C} 0 0 1 ${P3_arc.x.toFixed(2)} ${P3_arc.y.toFixed(2)} ` +
        `A ${INNER_R} ${INNER_R} 0 ${large} 0 ${P4_arc.x.toFixed(2)} ${P4_arc.y.toFixed(2)} ` +
        `A ${R_C} ${R_C} 0 0 1 ${P4_line.x.toFixed(2)} ${P4_line.y.toFixed(2)} Z`;

      const midAngleDeg = START_ANG + i * SEG_ANG + SEG_ANG / 2;
      const rText = (OUTER_R + INNER_R) / 2;
      const rotateText = midAngleDeg + 90;

      const lines = isSpecial ? ['TRY', 'NEXT', 'TIME'] : [seg.prize];
      const textLines = lines.map((line, j) => {
        const yOffset = (j - (lines.length - 1) / 2) * 15;
        return { text: line, yOffset };
      });

      return {
        segment: seg,
        pathData,
        fill,
        textColor,
        textTransform: `rotate(${rotateText}, ${CX}, ${CY}) translate(${CX}, ${CY - rText})`,
        textLines,
      };
    });
  }

  private async updateSegmentValues(): Promise<void> {
    // If free spin is available, show free spin values
    if (this.freeSpinAvailable) {
      this.updateSegmentsForFreeSpin();
      return;
    }

    const selectedRaw = parseFloat(this.spinAmount) || 5;
    const selectedAmount = this.normalizeSpinAmount(selectedRaw);
    this._spinAmount = selectedAmount.toString();

    const mapped =
      this.amountSegmentMap[selectedAmount] ||
      this.createDynamicSegments(selectedAmount);

    this.segments = mapped.map((s) => ({ ...s }));

    this.wheelGradient = this.buildWheelGradient();

    this.updateSvgSegments();

    this.cdr.detectChanges();
  }

  private normalizeSpinAmount(amount: number): number {
    if (!Number.isFinite(amount)) return 5;
    return Math.min(20, Math.max(1, Math.round(amount)));
  }

  private createDynamicSegments(amount: number): SpinnerSegment[] {
    const safe = this.normalizeSpinAmount(amount);
    const lesser = Math.max(0, safe - 1);

    return [
      { id: 'seg-01', prize: `$${safe}`, icon: 'heroTrophy' },
      { id: 'seg-02', prize: `$${safe}`, icon: 'ionDiamond' },
      { id: 'seg-03', prize: `$${safe}`, icon: 'heroCurrencyDollar' },
      { id: 'seg-04', prize: `$${lesser}`, icon: 'hugeMoneyBag02' },
      { id: 'seg-05', prize: '$0', icon: 'heroGift' },
      { id: 'seg-06', prize: `$${safe + 1}`, icon: 'heroTrophy' },
      { id: 'seg-07', prize: `$${safe}`, icon: 'ionDiamond' },
      { id: 'seg-08', prize: `$${safe + 2}`, icon: 'heroCurrencyDollar' },
      { id: 'seg-09', prize: 'Try Next Time', icon: 'heroGift' },
      { id: 'seg-10', prize: `$${safe + 3}`, icon: 'hugeMoneyBag02' },
    ];
  }

  // Free Spin Properties
  // readonly freeSpinValues = [0, 1, 3, 2, 5, 4, 7, 6, 9, 8];
  private freeSpinValues: SpinnerSegment[] = [
    { id: 'seg-01', prize: '$0', icon: 'heroTrophy' },
    { id: 'seg-02', prize: '$2', icon: 'ionDiamond' },
    { id: 'seg-03', prize: '$1', icon: 'heroTrophy' },
    { id: 'seg-04', prize: '$3', icon: 'hugeMoneyBag02' },
    { id: 'seg-05', prize: '$5', icon: 'heroCurrencyDollar' },
    { id: 'seg-06', prize: '$4', icon: 'ionDiamond' },
    { id: 'seg-07', prize: '$6', icon: 'heroCurrencyDollar' },
    { id: 'seg-08', prize: '$9', icon: 'hugeMoneyBag02' },
    { id: 'seg-09', prize: '$7', icon: 'heroGift' },
    { id: 'seg-10', prize: '$8', icon: 'heroCurrencyDollar' },
  ];
  private updateSegmentsForFreeSpin(): void {
    // Create segments from free spin values (0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5)
    const icons = [
      'heroTrophy',
      'ionDiamond',
      'heroCurrencyDollar',
      'hugeMoneyBag02',
      'heroGift',
    ];
    this.segments = this.freeSpinValues;
    // this.segments = this.freeSpinValues.map((value, index) => ({
    //   id: `free-seg-${index + 1}`,
    //   prize: `$${value}`,
    //   icon: icons[index % icons.length],
    // }));

    this.wheelGradient = this.buildWheelGradient();
    this.isBalanceSufficient = true;
    this.isSpinAllowed = true;
    this.updateSvgSegments();
    this.cdr.detectChanges();
  }

  private updateFreeSpinFormattedTime(): void {
    const hours = Math.floor(this.freeSpinRemainingTime / 3600);
    const minutes = Math.floor((this.freeSpinRemainingTime % 3600) / 60);
    const seconds = this.freeSpinRemainingTime % 60;

    this.freeSpinFormattedTime = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  freespincheck: boolean = false;
  isBalanceSufficient: boolean = false;

  async freeSpin() {
    await this.updateSegmentValues();
  }

  ngOnDestroy(): void {
    if (this.highlightTimeout) {
      clearTimeout(this.highlightTimeout);
    }
    if (this.freeSpinCountdownInterval) {
      clearInterval(this.freeSpinCountdownInterval);
    }
    if (this.winnerModalTimeout) {
      clearTimeout(this.winnerModalTimeout);
    }
  }

  allowedSpinAmounts = [1, 2, 3, 4, 5, 10, 15, 20];

  freeSpinAvailable: boolean = false;
  fresspinWindowIsOpen: boolean = true;
  freeSpinRemainingTime: number = 0;
  freeSpinFormattedTime: string = '';
  private freeSpinCountdownInterval: any;

  incrementSpinAmount(): void {
    if (this.freeSpinAvailable) return;
    const current = this.normalizeSpinAmount(Number(this.spinAmount) || 1);
    if (current < 20) {
      this.spinAmount = (current + 1).toString();
    }
  }

  decrementSpinAmount(): void {
    if (this.freeSpinAvailable) return;
    const current = this.normalizeSpinAmount(Number(this.spinAmount) || 1);
    if (current > 1) {
      this.spinAmount = (current - 1).toString();
    }
  }

  selectSpinAmount(amount: number): void {
    if (this.freeSpinAvailable) return;
    this.spinAmount = this.normalizeSpinAmount(amount).toString();
  }

  customerBetWinningAmount: number = 0;

  createCustomerBetPayload() {
    return {
      betType: 'spinner',
      customerId: localStorage.getItem('customerId'),
      bet: this.spinAmount,
    };
  }

  trackByHistoryNo(index: number, item: { no: number }): number {
    return item.no;
  }

  private addSpinHistory(winAmount: string): void {
    const lastNo = this.spinHistory.length
      ? Math.max(...this.spinHistory.map((h) => h.no))
      : 0;

    this.spinHistory = [
      {
        no: lastNo + 1,
        win: winAmount,
        date: this.formatHistoryDate(new Date()),
      },
      ...this.spinHistory,
    ].slice(0, 12);
  }

  private formatHistoryDate(date: Date): string {
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);

    let hour = date.getHours();
    const minute = date.getMinutes().toString().padStart(2, '0');
    const ampm = hour >= 12 ? 'pm' : 'am';
    hour = hour % 12 || 12;

    return `${month}/${day}/${year}, ${hour}:${minute} ${ampm}`;
  }

  openLoginModal() {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('token');
      if (token) {
        this.router.navigate(['/dashboard/spinner']);
      } else {
        this.router.navigate(['/login'], {
          queryParams: { redirectUrl: '/dashboard/spinner' },
        });
      }
    }
  }

  trackByIndex(index: number): number {
    return index;
  }
}
